export default function Spin() {
  return {}
}
